import { render, staticRenderFns } from "./device-detail-panel.vue?vue&type=template&id=57844c4f&scoped=true"
import script from "./device-detail-panel.vue?vue&type=script&lang=js"
export * from "./device-detail-panel.vue?vue&type=script&lang=js"
import style0 from "./device-detail-panel.vue?vue&type=style&index=0&id=57844c4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57844c4f",
  null
  
)

export default component.exports